/**
 * Single source of truth for headline organisation stats shown on the
 * home page (Hero + About sections). Update values here — they render
 * identically on every viewport. The ODL total is dynamic (CMS setting)
 * and read via `useOdlCount`.
 */

export type HeroStat = {
  /** Numeric value used for the counter animation. */
  value: number;
  /** Text rendered directly after the value (e.g. "+" or " z 77"). */
  suffix?: string;
  /** Short label shown under the value. */
  label: string;
  /** Optional longer label used by the About cards. */
  longLabel?: string;
};

/** Year the Stowarzyszenie became an Ośrodek Działaj Lokalnie. */
export const DL_START_YEAR = 2016;

/** Number of dofinansowane projekty. */
export const PROJECTS_COMPLETED = 50;

export function getYearsInDL(now: Date = new Date()): number {
  return Math.max(0, now.getFullYear() - DL_START_YEAR);
}

/**
 * Build the hero counter tiles.
 * @param odlCount total number of ODL centres in Poland (from CMS).
 */
export function getHeroStats(odlCount: number): HeroStat[] {
  return [
    {
      value: getYearsInDL(),
      label: 'lat w programie Działaj Lokalnie',
      longLabel: 'lat w programie Działaj Lokalnie',
    },
    {
      value: 1,
      suffix: ` z ${odlCount}`,
      label: 'Ośrodków Działaj Lokalnie',
      longLabel: 'Ośrodków Działaj Lokalnie w Polsce',
    },
    {
      value: PROJECTS_COMPLETED,
      suffix: '+',
      label: 'dofinansowanych projektów',
      longLabel: 'dofinansowanych projektów',
    },
  ];
}
